"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var IoMdClose_1 = require("@react-icons/all-files/io/IoMdClose");
function Modal(_a) {
    var onClose = _a.onClose, open = _a.open, children = _a.children, title = _a.title, _b = _a.className, className = _b === void 0 ? "" : _b, _c = _a.disableBackdropClick, disableBackdropClick = _c === void 0 ? false : _c;
    return ((0, jsx_runtime_1.jsx)(StyledModal, __assign({ slots: { backdrop: material_1.Backdrop }, slotProps: {
            backdrop: {
                timeout: 500,
            },
        }, "aria-labelledby": "transition-modal-title", "aria-describedby": "transition-modal-description", open: open, onClose: !disableBackdropClick ? onClose : function () { }, className: "".concat(className, " twap-modal"), closeAfterTransition: true }, { children: (0, jsx_runtime_1.jsx)(material_1.Fade, __assign({ in: open }, { children: (0, jsx_runtime_1.jsxs)(StyledModalContent, __assign({ className: "twap-modal-content", id: "twap-modal-content" }, { children: [onClose && ((0, jsx_runtime_1.jsx)(StyledClose, __assign({ className: "twap-ui-close", onClick: onClose }, { children: (0, jsx_runtime_1.jsx)(IoMdClose_1.IoMdClose, {}) }))), title && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(StyledTitle, { children: title }), (0, jsx_runtime_1.jsx)(StyledSeparator, {})] })), children] })) })) })));
}
exports.default = Modal;
var StyledSeparator = (0, material_1.styled)(material_1.Box)({
    height: 20,
});
var StyledTitle = (0, material_1.styled)(material_1.Box)({
    textAlign: "center",
    fontWeight: 500,
    fontSize: 17,
});
var StyledClose = (0, material_1.styled)(material_1.IconButton)({
    position: "absolute",
    right: 7,
    top: 7,
    svg: {
        width: 25,
        height: 25,
    },
});
var StyledModal = (0, material_1.styled)(material_1.Modal)({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
});
var StyledModalContent = (0, material_1.styled)(material_1.Box)({
    maxWidth: 500,
    width: "calc(100% - 30px)",
    position: "relative",
    maxHeight: "95vh",
});
